import { useCallback } from 'react';
export const useOnMouseEnter = ({ index, setCurrentIndex }) => {
    const onMouseEnter = useCallback(() => {
        if (setCurrentIndex)
            setCurrentIndex(index);
    }, [index, setCurrentIndex]);
    return onMouseEnter;
};
